import CustomBreadcrumbs from 'src/legacy/components/custom-breadcrumbs';
import { useLocales } from 'src/legacy/locales';
import { useSelector } from 'src/legacy/redux/store';
import { PATH_DASHBOARD } from 'src/legacy/routes/paths';

import {
  defaultTabs,
  useCustomerDetailsNavigatorContext,
} from './CustomerDetailsNavigatorContext';

export const Breadcrumbs = () => {
  const { currentTab } = useCustomerDetailsNavigatorContext();
  const { translate } = useLocales();

  const { selectedCustomer } = useSelector((state) => state.customer);

  const pageName =
    defaultTabs.find(({ value }) => value === currentTab)?.label ||
    `${translate('profile')}`;

  return (
    <CustomBreadcrumbs
      heading={selectedCustomer?.name || ''}
      links={[
        { href: PATH_DASHBOARD.root, name: `${translate('dashboard')}` },
        {
          href: PATH_DASHBOARD.customer.root,
          name: `${translate('customers')}`,
        },
        { name: `${translate(pageName)}` },
      ]}
    />
  );
};
